import {setAPILanguage} from './bundle'

class StoreLocator{
    constructor(nextContainer){

        this.container = nextContainer
        this.language = this.container.getAttribute('data-language')
        this.stores = []
        this.markers = []
        this.colors = {
            tiffany: '#81D8D0',
            black: '#000'
        }
        this.prev_infowindow = false; 
        this.utils = {
            phpRound: (number, precision) => {
                let factor              = Math.pow(10, precision)
                let tempNumber          = number * factor
                let roundedTempNumber   = Math.round(tempNumber)
                return roundedTempNumber / factor

            },
            sortByDistance: (a,b) => {
                let result = 0
                if( a["distance"] > b["distance"] ){
                    result = 1
                }
                else if( a["distance"] < b["distance"] ){
                    result = -1
                }
                return result
            } 
        }
           
        this.config = {

        }

        // this.initLat = 43.2387008
        // this.initLng = 13.7483738
        this.initLat = 44.4730307
        this.initLng = 11.3851039
        this.zoom = 7

        this.isSearchRunning = false
        this.form = this.container.querySelector('#store-locator-form')
        this.addressInput = this.container.querySelector('#address-input')
        this.searchButton = this.container.querySelector('#searchButton')
        this.storeList = this.container.querySelector('#store-list')

        // this.storeList.addEventListener('wheel', e => {
        //     e.preventDefault()
        //     console.log(e)
        //     return
        // })

        this.initEvents()
        // console.log(this.zoom)

    }

    initEvents(){

        this.form.addEventListener('submit', e => {
            e.preventDefault()
            return false
        })
        this.searchButton.addEventListener('click', () => {
            this.searchLocations()
        })
        this.initMap()
        this.initSearchLocations()
        this.initSearchField()

    }

    initMap(){
        // let latitude = 43.2387008
        // let longitude = 13.7483738
        this.map = new google.maps.Map(document.getElementById('map'), {
            center: { lat: this.initLat, lng: this.initLng },
            defaultCountry: 'IT',
            zoom: this.zoom,
            // disableDefaultUI: true,
            scrollwheel: false,
            // navigationControl: false,
            mapTypeControl: false,
            // scaleControl: false,
            draggable: true,
            styles: [
                {
                    "featureType": "all",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "saturation": 36
                        },
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 40
                        }
                    ]
                },
                {
                    "featureType": "all",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 16
                        }
                    ]
                },
                {
                    "featureType": "all",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#f0f0f0"
                        },
                        {
                            "lightness": 20
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 17
                        },
                        {
                            "weight": 1.2
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#c9c3c3"
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "color": "#fef7f7"
                        },
                        {
                            "weight": "0.94"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 20
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 21
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "color": "#dcdcdc"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#232323"
                        },
                        {
                            "lightness": 17
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 29
                        },
                        {
                            "weight": 0.2
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#382b22"
                        },
                        {
                            "lightness": "5"
                        },
                        {
                            "saturation": "-9"
                        },
                        {
                            "gamma": "2.61"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 18
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#50453e"
                        },
                        {
                            "lightness": "13"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 16
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 19
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 17
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": "-56"
                        },
                        {
                            "saturation": "-9"
                        },
                        {
                            "weight": "0.01"
                        },
                        {
                            "gamma": "1.25"
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                }
            ]
        })

        if(this.getDefaultMapCenter()){
            this.map.setCenter(this.getDefaultMapCenter())
        }
        this.infoWindow = new google.maps.InfoWindow()

        google.maps.event.trigger(this.map, 'resize')
        google.maps.event.trigger(this.map, 'center_changed')
    }

    getDefaultMapCenter(){
        let location 	= false
        let address 	= "Italia"
        let geocoder 	= new google.maps.Geocoder()

        geocoder.geocode( {'address': address}, function(results, status) {
            if (status == google.maps.GeocoderStatus.OK){                    
                location = results[0].geometry.location
            }
            else{
                location = new google.maps.LatLng(this.initLat,this.initLng)
            }
        })
        return location
    }

    initSearchLocations(){
        let formData = new FormData(this.form)
        let request = new XMLHttpRequest()
        let url = document.getElementById('uri').value + '/AJAX/store-locator.php'
        request.open('POST', url, true)
        request.onreadystatechange = () => {
            if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
                let resultObj = JSON.parse(request.response)
                this.stores = resultObj.filter(obj => obj.latitudine !== '')
                resultObj.forEach(o => {
                    // console.log(o)
                })
                this.searchLocations()
            }
        }
        request.send(formData)


        if (this.getDefaultMapCenter()){
            this.map.setCenter(this.getDefaultMapCenter())
        }        
    }


    initSearchField(){
        let options = {
            types: ['geocode'],
        }
        let autocomplete = new google.maps.places.Autocomplete(this.addressInput, options)
        
        autocomplete.addListener('place_changed', () => {
            console.log('changed')
            // console.log('place changed')
            let originLocation = this.map.getCenter();
            const place = autocomplete.getPlace()
            // Recenter the map to the selected address
            originLocation = place.geometry.location;
            this.map.setCenter(originLocation);
            // this.map.setZoom(9);
            // console.log(place);
            this.searchLocations()
        })

    }

    searchLocations(){
        let address,
            geocoder,
            customZoom,
            center,
            formatted_address

        address 	= "IT " + this.addressInput.value
        geocoder 	= new google.maps.Geocoder()
        customZoom 	= this.zoom
        
        if (!this.addressInput.value){
            address 	= "Italia"
            customZoom 	= 5
        }
        else{
            customZoom 	= 9
        }     
        // console.log(this.addressInput.value)

        geocoder.geocode({address: address}, (results, status) => {
            if (status == google.maps.GeocoderStatus.OK){
                center = results[0].geometry.location
                // console.log(center.lat())
                formatted_address = results[0].formatted_address
                this.searchLocationsNear(center.lat(), center.lng(), formatted_address)
                this.map.setCenter(center)
                if (customZoom != 0){
                    this.map.setZoom(customZoom)
                }
            }
            else{
                alert(address + ' non trovato.')
            }
        })  
    }


    searchLocationsNear(lat, lng, human_address){
        // console.log(lat, lng)
        if (this.isSearchRunning){
            return
        }
        this.initNewSearch()
        // build post parameters
        let params = {
            radius: 25,
            // type: StoreFinder.searchType.find('input[name="type_field"]:checked').value
        }
        // console.log(this.addressInput.value)
        // use lat/lng only if address is available
        if (this.addressInput.value){
            params.lat = lat
            params.lng = lng
        }

        let _lat = typeof params.lat !== 'undefined' ? params.lat : ''
        let _lng = typeof params.lng !== 'undefined' ? params.lng : ''
        
        // console.log(_lat)

        let data                = []
        data["totalRecords"]    = 0
        data["radius"]          = params.radius
        data["items"]           = []

        let stores = this.stores

        // console.log(params.lat)
        if ( _lat == '' || _lng == '' ){
            for (let j = 0; j < stores.length; j++){
                data["items"].push(stores[j])
                data["totalRecords"]++
            }
        }
        else{
            let distance
            for (let j = 0; j < stores.length; j++){
                distance = 6371 * Math.acos( Math.cos( (lat / 180) * Math.PI ) * Math.cos( (stores[j]["latitudine"] / 180) * Math.PI ) * Math.cos( ( (stores[j]["longitudine"] / 180) * Math.PI ) - (lng / 180) * Math.PI ) + Math.sin( (stores[j]["latitudine"] / 180) * Math.PI ) * Math.sin( (lat / 180) * Math.PI ) )
                // console.log(distance)
                // data["items"].push(stores[j])
                // if (distance < params.radius){
                    stores[j]["show_distance"] 	= true
                    stores[j]["distance"] = this.utils.phpRound(distance, 2)
                    data["items"].push(stores[j])
                    data["totalRecords"]++
                // }
                // data["items"].push(stores[j])
                distance = undefined
            }
            console.log(data['items'])
            data["items"].sort(this.utils.sortByDistance)
            console.log(data['items'])
        }
        
        data["items"].forEach((store, index) => {
            // console.log(store)
            store.front_index = index
            store = this.createMarker(store)            
            this.createListItem(store)

        })

        this.afterSearch();
        // callback with store data
        // StoreFinder.config.onComplete(data);        
        // console.log(data)
    }    

    afterSearch(){
        this.isSearchRunning = false
    }

    initNewSearch(){
        this.isSearchRunning = true
        // StoreFinder.config.onStart()
        // StoreFinder.ajaxLoader.show()
        this.clearLocations()
    }

    clearLocations(){
        // console.log('clear locations')
        this.infoWindow.close()
        for (let i = 0; i < this.markers.length; i++){
            this.markers[i].setMap(null)
        }
        this.markers.length = 0
        // this.container.querySelector("#store-results").scrollTop(0)
        this.storeList.innerHTML = ''
    }

    createMarker(store){      
        var latlng = new google.maps.LatLng(
            parseFloat(store.latitudine),
            parseFloat(store.longitudine)
        )
        const infowindowContent =  `<div class="infowindow-content">
                            <h3>${store.titolo}</h3>
                            <p>${store.indirizzo_completo}</p>
                            <a target="_blank" href="${store.map_url}">Map</a>
                          </div>
                        `
        let infoWindow = new google.maps.InfoWindow({
            content: infowindowContent
        })
       
        var marker = new google.maps.Marker({
            map: this.map,
            icon: {
                path: "M6.000,0.013 C2.686,0.013 -0.000,2.700 -0.000,6.014 C-0.000,9.328 6.000,16.015 6.000,16.015 C6.000,16.015 12.000,9.328 12.000,6.014 C12.000,2.700 9.314,0.013 6.000,0.013 Z",
                scale: 1.5,
                fillOpacity: 1,
                fillColor: this.colors.black,
                strokeColor: this.colors.tiffany,
                anchor: new google.maps.Point(6, 18),
                origin: new google.maps.Point(0, 0)
            },
            draggable: false,
            position: latlng
        })

        this.handleHoverOnMarker(marker)

        marker.id = store.id
        
        infoWindow.addListener('closeclick', ()=>{
            infoWindow.close()
            this.markers.forEach( (marker, key) => {
                let icon 				= marker.getIcon();
                icon.scale 			= 1.5;
                icon.fillColor = this.colors.black
                icon.strokeColor = this.colors.tiffany
                marker.setIcon(icon)
        
            })            
        })

        google.maps.event.addListener(marker, 'click', () => {
            //todo: terminare la funzione scrollList
            // this.scrollList(store.id)
            this.changeIcon(marker)
            this.map.setZoom(11)
            this.map.setCenter(latlng)

            //Infowindow
            if(this.prev_infowindow ) {
                this.prev_infowindow.close();
            }            
            this.prev_infowindow = infoWindow
            infoWindow.open({
                anchor: marker,
                map: this.map
            })
        })

        store.marker_id = this.markers.length
        this.markers.push(marker)

        return store

    }

    handleHoverOnMarker(marker){
        google.maps.event.addListener(marker, "mouseover", () => {
            let icon = marker.getIcon()
            icon.fillColor = this.colors.tiffany
            icon.strokeColor = this.colors.tiffany
            marker.setIcon(icon)
            marker.setZIndex(9999)
        })
        google.maps.event.addListener(marker, "mouseout", () => {
            let icon = marker.getIcon()
            if (icon.scale != 3) {
                icon.fillColor = this.colors.blackc
                icon.strokeColor = this.colors.tiffany
                marker.setIcon(icon)
                marker.zIndex = "auto"
            }
        })
    }

    changeIcon(marker){
        this.markers.forEach( (marker, key) => {
            let icon 				= marker.getIcon();
            icon.scale 			= 1.5;
            icon.fillColor = this.colors.black
            icon.strokeColor = this.colors.tiffany
            marker.setIcon(icon)

        })

        let icon 				= marker.getIcon();
        icon.scale 			= 3;
        icon.fillColor = this.colors.tiffany
        icon.strokeColor = this.colors.tiffany

        marker.setIcon(icon)
    }
    //todo: terminare la funzione scrollList
    scrollList(id){
        // console.log(this.stores)
        // this.stores.forEach(store => {
        //     document.querySelector('#store-'+store.id).classList.remove('active')
        // })
        // let selectedStore = document.querySelector('#store-'+id)
        // let selectedStoreRect = selectedStore.getBoundingClientRect()
        // console.log(selectedStoreRect)
        // let selectedStoreOffset = 
        // selectedStore.classList.add('active')
        // console.log('scrollList', id)
        // jQuery("#store-list").removeClass("active");
        // jQuery("#store-" + id).addClass("active");

        // jQuery("#store-results").stop().animate({
        //     scrollTop: jQuery("#store-" + id).position().top + jQuery("#store-results").scrollTop()
        // }, 500)

    }

    createListItem(store){
        // console.log(store)
        let storeHTML = '';
        let textView = this.language === 'it' ? 'Visita' : 'View'
        // var zonaCompetenzaLabel = '';
        storeHTML += '<div class="negozio" id="store-' + store.id + '" data-id="' + store.id + '" data-front-index="' + store.front_index + '">';
            storeHTML += '<a target="_blank" href="' + store.map_url + '">';
                storeHTML += '<div class="negozio__wrapper">';
                    storeHTML += '<div class="negozio__info">';
                        storeHTML += '<div class="titolo-negozio">';
                            storeHTML += '<p class="medium-text tiffany wulkan">' + store.titolo + '</p>';
                        storeHTML += '</div>';
                        storeHTML += '<div class="indirizzo-negozio">';
                            // storeHTML += '<p>' + store.indirizzo + '</p>';
                            storeHTML += '<p>' + store.indirizzo_completo + '</p>';
                        storeHTML += '</div>';
                    storeHTML += '</div>';

                    storeHTML += '<div class="open-link">';
                        storeHTML += '<div class="open-link__icon">';
                            storeHTML += '<div class="img">';
                                storeHTML += '<svg x="0px" y="0px" viewBox="0 0 72 72" style="enable-background:new 0 0 72 72;" xml:space="preserve">';
                                    storeHTML += '<path class="svg-circle-thin" class="svg-circle-thin" d="M36,2.5L36,2.5c18.5,0,33.5,15,33.5,33.5l0,0c0,18.5-15,33.5-33.5,33.5l0,0c-18.5,0-33.5-15-33.5-33.5l0,0 C2.5,17.5,17.5,2.5,36,2.5z"/>';
                                    storeHTML += '<path class="svg-circle-progress"d="M36,2.5L36,2.5c18.5,0,33.5,15,33.5,33.5l0,0c0,18.5-15,33.5-33.5,33.5l0,0c-18.5,0-33.5-15-33.5-33.5l0,0 C2.5,17.5,17.5,2.5,36,2.5z"/>';
                                    storeHTML += '<path class="svg-arrow" d="M27,43.6l1.4,1.4l14.8-14.8l0,11.4l1.9,0V27H30.5l0,1.9h11.4L27,43.6z"/>';
                                storeHTML += '</svg>';
                            storeHTML += '</div>';
                        storeHTML += '</div>';
                        storeHTML += '<div class="open-link__label">';                   
                            storeHTML += '<span class="uppercase">';
                                storeHTML += textView;
                            storeHTML += '</span>';
                        storeHTML += '</div>';
                    storeHTML += '</div>'; 
                storeHTML += '</div>';
            storeHTML += '</a>';
        storeHTML += '</div>';
        this.storeList.insertAdjacentHTML('beforeend',storeHTML)
    }


    
}

export {StoreLocator}